import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Skeleton from '@material-ui/lab/Skeleton';
import Grid from '@material-ui/core/Grid';
import Hidden from '@material-ui/core/Hidden';

const useStyles = makeStyles(theme => ({
  surveyContainer: {
    background: '#F8F9F9',
    [theme.breakpoints.down('sm')]: {
      paddingBottom: 20,
    },
  },
  surveyWrapper: {
    background: '#fff',
    borderRadius: 3,
    padding: '20px 5%',
  },
  surveyWrapper2: {
    background: '#fff',
    borderRadius: 3,
    padding: '20px 5%',
    marginTop: 20,
  },
  header: {
    margin: 'auto',
  },
  text: {
    transform: 'scale(1, 0.8)',
  },
}));

function PageSkeleton({ isFullWidth }) {
  const classes = useStyles();
  return (
    <>
      <Hidden smDown>
        <Grid
          item
          xs={12}
          md={isFullWidth ? 12 : 9}
          className={classes.surveyContainer}
        >
          <Grid container>
            <Grid item xs={12} className={classes.surveyWrapper}>
              <Grid container spacing={2}>
                <Grid item>
                  <Skeleton variant="rect" height={88} width={88} />
                </Grid>
                <Grid item xs className={classes.header}>
                  <Skeleton
                    variant="text"
                    height={20}
                    classes={{ text: classes.text }}
                  />
                  <Skeleton
                    variant="text"
                    height={37}
                    classes={{ text: classes.text }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Skeleton
                    variant="text"
                    height={22}
                    classes={{ text: classes.text }}
                  />
                  <Skeleton
                    variant="text"
                    height={22}
                    classes={{ text: classes.text }}
                  />
                  <Skeleton
                    variant="text"
                    height={22}
                    classes={{ text: classes.text }}
                  />
                  <Skeleton
                    variant="text"
                    height={22}
                    classes={{ text: classes.text }}
                  />
                  <Skeleton
                    variant="text"
                    height={22}
                    classes={{ text: classes.text }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Skeleton variant="rect" height={256} />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} className={classes.surveyWrapper2}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Skeleton
                    variant="text"
                    height={29}
                    width="80%"
                    classes={{ text: classes.text }}
                  />
                </Grid>
                <Grid item xs={4}>
                  <Skeleton variant="rect" height={256} />
                </Grid>
                <Grid item xs={4}>
                  <Skeleton variant="rect" height={256} />
                </Grid>
                <Grid item xs={4}>
                  <Skeleton variant="rect" height={256} />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        {!isFullWidth && (
          <Grid item xs={12} md={3} className={classes.surveyContainer}>
            <Grid container>
              <Grid item xs={12} className={classes.surveyWrapper}>
                <Skeleton
                  variant="text"
                  height={20}
                  classes={{ text: classes.text }}
                />
                <Skeleton variant="rect" height={64} />
              </Grid>
              <Grid item xs={12} className={classes.surveyWrapper2}>
                <Skeleton
                  variant="text"
                  height={20}
                  classes={{ text: classes.text }}
                />
                <Skeleton variant="rect" height={256} />
              </Grid>
            </Grid>
          </Grid>
        )}
      </Hidden>
      <Hidden mdUp>
        <Grid item xs={12} className={classes.surveyContainer}>
          <Grid container>
            <Grid item xs={12} className={classes.surveyWrapper}>
              <Grid container spacing={2}>
                <Grid item>
                  <Skeleton variant="rect" height={88} width={88} />
                </Grid>
                <Grid item xs className={classes.header}>
                  <Skeleton
                    variant="text"
                    height={20}
                    classes={{ text: classes.text }}
                  />
                  <Skeleton
                    variant="text"
                    height={37}
                    classes={{ text: classes.text }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Skeleton
                    variant="text"
                    height={22}
                    classes={{ text: classes.text }}
                  />
                  <Skeleton
                    variant="text"
                    height={22}
                    classes={{ text: classes.text }}
                  />
                  <Skeleton
                    variant="text"
                    height={22}
                    classes={{ text: classes.text }}
                  />
                  <Skeleton
                    variant="text"
                    height={22}
                    classes={{ text: classes.text }}
                  />
                  <Skeleton
                    variant="text"
                    height={22}
                    classes={{ text: classes.text }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Skeleton variant="rect" height={256} />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} className={classes.surveyWrapper2}>
              <Skeleton
                variant="text"
                height={20}
                classes={{ text: classes.text }}
              />
              <Skeleton variant="rect" height={64} />
            </Grid>
            <Grid item xs={12} className={classes.surveyWrapper2}>
              <Skeleton
                variant="text"
                height={20}
                classes={{ text: classes.text }}
              />
              <Skeleton variant="rect" height={128} />
            </Grid>
          </Grid>
        </Grid>
      </Hidden>
    </>
  );
}

PageSkeleton.propTypes = {
  isFullWidth: PropTypes.bool,
};

export default PageSkeleton;
